module.exports = __webpack_public_path__ + "img/Shirts@2x.fac95c2a.png";